export default __webpack_public_path__ + "static/media/caen10.6431806f.jpg";